<template>
  <div class="edit-table-container" ref="container">
    <div class="d-flex">
      <PageHeader
        style="flex: 1;"
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
    </div>
    <div class="d-flex mt-2">
      <div class="edit-table mr-2">
        <SkuTable
          ref="main"
          :tableData="tableData"
          :loading="loading"
          :tablePage="page"
          @reload="reload"
          @current-change="currentChange"
        >
          <pagination
            size="small"
            align="right"
            slot="pager"
            :current-page="page.curPage"
            :page-size="page.pageSize"
            :page-total="page.pageTotal"
            @change="handlePaginationChange"
            :layouts="['Total', 'Sizes', 'PrevPage', 'NextPage']"
          />
        </SkuTable>
      </div>
      <div class="edit-form">
        <EditForm
          ref="editForm"
          :amzReplenishmentDetailCode="currentRowKey"
          @reload="reload"
          @update-success="$emit('update-success')"
        />
      </div>
    </div>
    <div class="d-flex justify-content-end my-2">
      <el-button
        type="danger"
        size="small"
        @click="$refs.editForm.stopReplenishment()"
      >
        {{ $l('btn_stopReplenishment') || '该产品不再补货' }}
      </el-button>
      <el-button type="warning" size="small" @click="$refs.editForm.del()">
        {{ $l('INDEX.btn_rep_cancel') || '不补货' }}
      </el-button>
      <el-button type="primary" size="small" @click="$refs.editForm.save()">
        {{ $l('INDEX.btn_rep_save') || '保存' }}
      </el-button>
      <el-button
        type="success"
        size="small"
        @click="$refs.editForm.save({ isSaveAndSubmit: 'Y' })"
      >
        {{ $l('INDEX.btn_rep_save_submit') || '保存并提交' }}
      </el-button>
    </div>
  </div>
</template>
<script>
import SkuTable from './table.vue'
import PageHeader from './header.vue'
import EditForm from '../vc-sku-edit-form/main.vue'
import $confirm from '../can-reload-dialog/index.js'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: { SkuTable, PageHeader, EditForm },
  props: { amzReplenishmentCode: { type: String, default: '' } },
  data() {
    return {
      usePage: true,
      // 当前选中行，初始值为NULL
      currentRow: null,
      levelOptions: [],
      alertLevel: 0,
    }
  },
  computed: {
    tableDataMap() {
      if (!this.tableData || !this.tableData.length) return {}
      return Object.fromEntries(
        this.tableData.map((o) => [o.amzReplenishmentDetailCode, o])
      )
    },
    tableCode() {
      return Object.keys(this.tableDataMap)
    },
    currentRowKey() {
      if (!this.currentRow) return ''
      return this.currentRow.amzReplenishmentDetailCode
    },
  },
  watch: {
    tableCode: {
      handler(codes) {
        // 判断是否存在数据
        if (!codes || !codes.length) {
          // 清空选中的行
          this.clearCheckRow()
          return
        }

        // 判断选中的记录是否在新的表格里存在
        if (this.currentRowKey && codes.includes(this.currentRowKey)) {
          this.reloadEditForm()
          return
        }

        // 不存在则默认选中列表第一个
        const firstCode = codes[0]
        this.currentRow = this.tableDataMap[firstCode]
        setTimeout(() => {
          // 设置选中行
          this.$refs.main.setCurrentRow(firstCode)
        }, 0)
      },
    },
  },
  methods: {
    async getData(form) {
      //  判断是否可以加载
      if (!(await this.isCanReload())) return
      await Promise.all([this.getTableData(form), this.getInvLevelTotal(form)])
    },
    getTableData(form) {
      this.loading = true
      this.$api
        .ecomAmzReplenishmentDetailListApi({
          ...form,
          ...this.page,
          alertLevel: this.alertLevel,
          amzReplenishmentCode: this.amzReplenishmentCode,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
          return true
        })
        .catch(() => {
          this.loading = false
          return false
        })
    },
    async getInvLevelTotal(form) {
      return this.$api
        .ecomAmzReplenishmentDetailInvLevelTotalApi({
          ...form,
          alertLevel: this.alertLevel,
          amzReplenishmentCode: this.amzReplenishmentCode,
        })
        .then((res) => {
          this.levelOptions = res.body.data
          return true
        })
        .catch(() => false)
    },
    /**
     * 表格选中事件
     */
    async currentChange({ row }) {
      // 判断用户是否修改了表单数据
      if (!(await this.isCanReload())) {
        // 表单有修改，用户不同意刷新
        // 将表格选中数据修改为原来选中的数据
        this.$refs.main.setCurrentRow(
          this.currentRow.amzReplenishmentDetailCode
        )
        return
      }
      this.currentRow = row
      this.$refs.main.setCurrentRow(this.currentRow.amzReplenishmentDetailCode)
    },
    /**
     * 清空选中的行
     */
    clearCheckRow() {
      this.currentRow = null
      this.$refs.main.clearCurrentRow()
    },
    /**
     * 刷新表单
     */
    reloadEditForm() {
      this.$refs.editForm.getData()
    },
    /**
     * 判断是否可以刷新列表以及表单数据
     */
    async isCanReload() {
      // 判断用户是否有修改表单数据
      if (!this.$refs.editForm) return false
      if (!this.$refs.editForm.getFormIsChange()) return true
      return await $confirm()
        .then(async (res) => {
          if (!res) return true
          return await this.$refs.editForm.submitSave()
        })
        .catch(() => false)
    },
    /**
     * 弹框关闭四事件
     */
    cancel() {
      // 判断表单是否有修改
      const formIsChange = this.$refs.editForm.getFormIsChange()
      if (!formIsChange) {
        this.$emit('close')
        return
      }

      // 打开自定义提示框，提示用户是否需要保存
      $confirm().then(async (res) => {
        // True 保存后关闭
        if (res) {
          if (!(await this.$refs.editForm.submitSave())) return
        }
        this.$emit('close')
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.edit-table-container {
  .edit-table {
    width: 40%;
  }
  .edit-form {
    width: 60%;
  }
}
</style>
